import { setToken, token } from 'odyssey';
import * as styled from 'styled-components';
import { normalize } from 'styled-normalize';

export const GlobalStyle = styled.createGlobalStyle`
  ${normalize}

  :root {
    ${({ theme }) => setToken('color-primary-brand', theme.customColors.primary)};
    ${({ theme }) => setToken('color-secondary-brand', theme.customColors.secondary)};
    ${({ theme }) => setToken('color-section-title', theme.sectionTitleColour)};
    ${({ theme }) => setToken('button-primary-bg', theme.customColors.primary)};
    ${({ theme }) => setToken('button-secondary-fg', theme.customColors.secondary)};
    ${({ theme }) => setToken('button-border-default-color', theme.customColors.primary)};
    ${({ theme }) => setToken('button-border-secondary-color', theme.customColors.secondary)};

    --sf-header-font: ${({ theme }) => theme.headerFont}, ${token('font-family')};
  }

  html,
  body {
    overflow-x: clip;
  }

  html {
    font-family: ${({ theme }) => theme.bodyFont}, ${token('font-family')};
    line-height: ${token('line-height')};
    font-size: ${token('paragraph-font-size')};
    color: ${token('color-text-dark')};
  }

  h1,
  h2,
  h3 {
    font-family: var(--sf-header-font);
    color: ${token('color-primary-brand')};
  }

  h1 {
    font-size: ${token('heading-1-mb-font-size')};
    font-weight: ${token('heading-1-mb-font-weight')};
    line-height: ${token('heading-1-mb-line-height')};

    /* @TODO use new media queries */
    @media screen and (min-width: 768px) {
      font-size: ${token('heading-1-dt-font-size')};
      font-weight: ${token('heading-1-dt-font-weight')};
      line-height: ${token('heading-1-dt-line-height')};
    }
  }

  h2 {
    font-size: ${token('heading-2-font-size')};
    font-weight: ${token('heading-2-font-weight')};
    line-height: ${token('heading-2-line-height')};
  }

  h3 {
    font-size: ${token('heading-3-font-size')};
    font-weight: ${token('heading-3-font-weight')};
    line-height: ${token('heading-3-line-height')};
  }

  a {
    text-decoration: none;
    color: ${token('color-secondary-brand')};
  }

  input {
    outline: none;
  }

  ul {
    list-style: disc;
  }

  p,
  ul,
  ol {
    margin: 0;
  }

  img.imgix-image {
    opacity: 0;
    transition: opacity 400ms ease;
  }

  img.lazyloaded {
    opacity: 1;
  }

  fieldset {
    padding: 0;
    margin: 0;
    border: none;
  }

  .underline {
    text-decoration: underline;
  }
`;
